export default __webpack_public_path__ + "static/media/online.2da159cd.jpeg";